import { render } from "./AuthenticateUserPage.vue?vue&type=template&id=2dffe1e5&scoped=true"
import script from "./AuthenticateUserPage.vue?vue&type=script&lang=ts"
export * from "./AuthenticateUserPage.vue?vue&type=script&lang=ts"

import "./AuthenticateUserPage.vue?vue&type=style&index=0&id=2dffe1e5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2dffe1e5"
/* hot reload */
if (module.hot) {
  script.__hmrId = "2dffe1e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2dffe1e5', script)) {
    api.reload('2dffe1e5', script)
  }
  
  module.hot.accept("./AuthenticateUserPage.vue?vue&type=template&id=2dffe1e5&scoped=true", () => {
    api.rerender('2dffe1e5', render)
  })

}

script.__file = "src/views/AuthenticateUserPage/AuthenticateUserPage.vue"

export default script